export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";